import clsx from 'clsx'
import {orderBy} from 'lodash'
import React from 'react'
import {Redirect, Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import {toDisplayPoints} from '../../../helpers/utils'

import Section from './Section'

const useStyles = makeStyles(assessmentStyles)
 
export default function PreviewResultsAssessment ({assessment, context}) {

  const classes = useStyles()

  const {assessmentId} = assessment
  const {translate, link, quizTypesMap} = context
  const {content = {}, results = {}, studentName = '', properties = {}} = assessment
  const {title, type} = content
  const assessmentLoaded = !context.quizSearch['assessment-results']

  const typeName = translate(quizTypesMap[type])

  const orderedSections = assessment.assessmentId == assessmentId
    ? orderBy(Object.values(content.sections || {}),'index')
    : []

  const sections = orderedSections.reduce((sections, section) => {
    const last = sections.length > 0
      ? sections[sections.length - 1]
      : {sectionEnds: -1}
    const sectionStarts = last.sectionEnds + 1
    const sectionEnds = sectionStarts + section.questions.length
    sections.push({...section, sectionStarts, sectionEnds})
    return sections
  }, [])

  const {points, total} = Object.values(results).reduce((acc, {points, total}) => ({total: acc.total + total, points: acc.points + points}), {total: 0, points: 0})

  const percentageText = `${Math.round(points / total * 100)}%`
  const pointsText = `${translate('points')}: ${toDisplayPoints(points + (properties.bonus || 0))} ${translate('of')} ${toDisplayPoints(total)}`

  return (
    // <Fade in={assessmentLoaded}>
      <Box className={classes.root}>
        <Box className={classes.header}>
          <Box className={classes.pointsWrapper}>
            <Box className={classes.percentage}>
              {percentageText}
            </Box>
            <Box className={classes.points}>
              {pointsText}
            </Box>
          </Box>
        </Box>
        <Box className={classes.preview}>
          {sections.map((section, sectionIndex)=> <Section key={section.id} {...{context, assessment, section, sectionIndex, sections}} />)}
        </Box>
      </Box>
    // </Fade>
  )
}

export function assessmentStyles (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'hidden',
    },
    header: {
      padding: '10px 20px 10px 10px',
      display: 'flex',
      flexDirection: 'column',
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start'
      }
    },
    pointsWrapper: {
      flexGrow: 1,
    },
    label: {
      color: '#4d5361',
      fontSize:'13pt',
      fontWeight: 'bold'
    },
    percentage: {
      marginTop: 5,
      fontSize:'50pt',
      color: '#df7317'
    },
    points: {
      color: '#4d5361',
      fontSize:'10pt',
    },
    notice: {
      color: '#4d5361',
      fontSize:'10pt',
    },
    filler: {
      flexGrow: 1
    },
    preview: {
      display: 'flex',
      flexDirection: 'column',
      padding: 10,
      flexGrow: 1,
      overflowY: 'auto'
    },
    question: {
      marginTop: 20,
      border: 'solid 1px #ccc',
      borderRadius: 2,
      backgroundColor: '#fff',
      '&:first-child': {
        marginTop: 0
      }
    }
  }
}
